<div #modalElement class="modal fade" id="{{id}}" tabindex="-1" role="dialog">
  <div class="modal-dialog wide-modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="close()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
        <spk-search-grid #searchGrid [list]="list" [title]="title" [defaultSortProperty]="sort" [leftLinks]="links" [filter]="filter" [command]="command" [autoload]="autoload"
          showSearch="true" [useQueryString]="false" [searchString]="searchString">
        </spk-search-grid>
      </div>
      <div class="modal-footer">
        <button id="{{id}}Dismiss" type="button" class="btn btn-default" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>